import React, { useState } from 'react';
import './Planes.css';

const Planes = () => {
  const [modalidad, setModalidad] = useState('virtual');
  const phoneNumber = '+51923651512';

  const planesVirtual = [
    {
      id: 1,
      title: 'Plan Mes de Cambios',
      duration: '1 mes',
      description: [
        'Consulta nutricional nutricional (40 min por videollamada: Zoom o Google Meet)',
        'Evaluación antropométrica (peso, % de grasa, talla y perímetros)',
        'Plan nutricional a medida con desglose de macronutrientes y calorías',
        'App nutricional con sistema de equivalentes y ajustes cada 3 semanas',
        'Kit de materiales personalizados: guías (intercambios, hormonas, comer fuera, entrenamiento), recetario (+ 50 recetas) y lista de compras',
        'Recomendación de suplementación según tu objetivo',
        'Monitoreo y seguimiento continuo por App móvil y WhatsApp'
      ],
      recommendation: 'Ideal si deseas empezar y conocer tu estado nutricional.',
      price: 'S/ 120',
      popular: false,
      hidden: true
    },
    {
      id: 2,
      title: 'Plan Esfuerzo Doble',
      duration: '2 meses',
      description: [
        'Consulta nutricional nutricional (40 min por videollamada: Zoom o Google Meet)',
        'Evaluación antropométrica (peso, % de grasa, talla y perímetros)',
        'Plan nutricional a medida con desglose de macronutrientes y calorías',
        'App nutricional con sistema de equivalentes y ajustes cada 3 semanas',
        'Kit de materiales personalizados: guías (intercambios, hormonas, comer fuera, entrenamiento), recetario (+ 50 recetas) y lista de compras',
        'Recomendación de suplementación según tu objetivo',
        'Monitoreo y seguimiento continuo por App móvil y WhatsApp'
      ],
      recommendation: 'Recomendado si buscas mayor seguimiento y mejores resultados.',
      price: 'S/ 200',
      popular: false
    },
    {
      id: 3,
      title: 'Plan Inicio de Cambio',
      duration: '3 meses',
      description: [
        'Consulta nutricional nutricional (40 min por videollamada: Zoom o Google Meet)',
        'Evaluación antropométrica (peso, % de grasa, talla y perímetros)',
        'Plan nutricional a medida con desglose de macronutrientes y calorías',
        'App nutricional con sistema de equivalentes y ajustes cada 3 semanas',
        'Kit de materiales personalizados: guías (intercambios, hormonas, comer fuera, entrenamiento), recetario (+ 50 recetas) y lista de compras',
        'Recomendación de suplementación según tu objetivo',
        'Monitoreo y seguimiento continuo por App móvil y WhatsApp'
      ],
      recommendation: 'Perfecto para formar hábitos saludables y sostenibles.',
      price: 'S/ 290',
      popular: false
    },
    {
      id: 4,
      title: 'Plan Compromiso Saludable',
      duration: '5 meses',
      description: [
        'Consulta nutricional nutricional (40 min por videollamada: Zoom o Google Meet)',
        'Evaluación antropométrica (peso, % de grasa, talla y perímetros)',
        'Plan nutricional a medida con desglose de macronutrientes y calorías',
        'App nutricional con sistema de equivalentes y ajustes cada 3 semanas',
        'Kit de materiales personalizados: guías (intercambios, hormonas, comer fuera, entrenamiento), recetario (+ 50 recetas) y lista de compras',
        'Recomendación de suplementación según tu objetivo',
        'Monitoreo y seguimiento continuo por App móvil y WhatsApp'
      ],
      recommendation: 'Pensado para cambios reales y duraderos.',
      price: 'S/ 400',
      popular: true
    },
    {
      id: 5,
      title: 'Plan Vida Plena 365',
      duration: '12 meses',
      description: [
        'Consulta nutricional nutricional (40 min por videollamada: Zoom o Google Meet)',
        'Evaluación antropométrica (peso, % de grasa, talla y perímetros)',
        'Plan nutricional a medida con desglose de macronutrientes y calorías',
        'App nutricional con sistema de equivalentes y ajustes cada 3 semanas',
        'Kit de materiales personalizados: guías (intercambios, hormonas, comer fuera, entrenamiento), recetario (+ 50 recetas) y lista de compras',
        'Recomendación de suplementación según tu objetivo',
        'Monitoreo y seguimiento continuo por App móvil y WhatsApp'
      ],
      recommendation: 'El plan más completo para transformar tu estilo de vida durante todo el año.',
      price: 'S/ 720',
      popular: false,
      hidden: true
    }
  ];

  const planesPresencial = [
    {
      id: 1,
      title: 'Plan Mes de Cambios',
      duration: '1 mes',
      description: [
        'Consulta nutricional nutricional 50 minutos',
        'Evaluación antropométrica (peso, % de grasa, % de músculo talla y perímetros)',
        'Plan nutricional a medida con ajustes cada 3 semanas',
        'App nutricional con sistema de equivalentes',
        'Kit de materiales personalizados: guías (intercambios, hormonas, comer fuera, entrenamiento), recetario (+ 50 recetas) y lista de compras',
        'Recomendación de suplementación según tu objetivo',
        'Evaluación de resultados de laboratorio',
        'Monitoreo y seguimiento continuo por App móvil y WhatsApp'
      ],
      recommendation: 'Ideal si deseas empezar y conocer tu estado nutricional.',
      price: 'S/ 200',
      popular: false
    },
    {
      id: 2,
      title: 'Plan Esfuerzo Doble',
      duration: '2 meses',
      description: [
        'Consulta nutricional nutricional 50 minutos',
        'Evaluación antropométrica (peso, % de grasa, % de músculo talla y perímetros)',
        'Plan nutricional a medida con ajustes cada 3 semanas',
        'App nutricional con sistema de equivalentes',
        'Kit de materiales personalizados: guías (intercambios, hormonas, comer fuera, entrenamiento), recetario (+ 50 recetas) y lista de compras',
        'Recomendación de suplementación según tu objetivo',
        'Evaluación de resultados de laboratorio',
        'Monitoreo y seguimiento continuo por App móvil y WhatsApp'
      ],
      recommendation: 'Recomendado si buscas mayor seguimiento y mejores resultados.',
      price: 'S/ 300',
      popular: false
    },
    {
      id: 3,
      title: 'Plan Inicio de Cambio',
      duration: '3 meses',
      description: [
        'Consulta nutricional nutricional 50 minutos',
        'Evaluación antropométrica (peso, % de grasa, % de músculo talla y perímetros)',
        'Plan nutricional a medida con ajustes cada 3 semanas',
        'App nutricional con sistema de equivalentes',
        'Kit de materiales personalizados: guías (intercambios, hormonas, comer fuera, entrenamiento), recetario (+ 50 recetas) y lista de compras',
        'Recomendación de suplementación según tu objetivo',
        'Evaluación de resultados de laboratorio',
        'Monitoreo y seguimiento continuo por App móvil y WhatsApp',
        'Invitado mensual (evaluación y diagnóstico gratuito)'
      ],
      recommendation: 'Perfecto para formar hábitos saludables y sostenibles.',
      price: 'S/ 400',
      popular: true
    },
    {
      id: 4,
      title: 'Plan Compromiso Saludable',
      duration: '6 meses',
      description: [
        'Consulta nutricional nutricional 50 minutos',
        'Evaluación antropométrica (peso, % de grasa, % de músculo talla y perímetros)',
        'Plan nutricional a medida con ajustes cada 3 semanas',
        'App nutricional con sistema de equivalentes',
        'Kit de materiales personalizados: guías (intercambios, hormonas, comer fuera, entrenamiento), recetario (+ 50 recetas) y lista de compras',
        'Recomendación de suplementación según tu objetivo',
        'Evaluación de resultados de laboratorio',
        'Monitoreo y seguimiento continuo por App móvil y WhatsApp',
        'Invitado mensual (evaluación y diagnóstico gratuito)'
      ],
      recommendation: 'Pensado para cambios reales y duraderos.',
      price: 'S/ 600',
      popular: false
    },
    {
      id: 5,
      title: 'Plan Vida Plena 365',
      duration: '12 meses',
      description: [
        'Consulta nutricional nutricional 50 minutos',
        'Evaluación antropométrica (peso, % de grasa, % de músculo talla y perímetros)',
        'Plan nutricional a medida con ajustes cada 3 semanas',
        'App nutricional con sistema de equivalentes',
        'Kit de materiales personalizados: guías (intercambios, hormonas, comer fuera, entrenamiento), recetario (+ 50 recetas) y lista de compras',
        'Recomendación de suplementación según tu objetivo',
        'Evaluación de resultados de laboratorio',
        'Monitoreo y seguimiento continuo por App móvil y WhatsApp',
        'Invitado mensual (evaluación y diagnóstico gratuito)'
      ],
      recommendation: 'El plan más completo para transformar tu estilo de vida durante todo el año.',
      price: 'S/ 900',
      popular: false,
      hidden: true
    }
  ];

  const handleModalidadChange = (tipo) => {
    setModalidad(tipo);
  };

  const handleWhatsAppClick = (plan) => {
    const message = `¡Hola! 👋 Me interesa obtener más información sobre el ${plan.title} en modalidad ${modalidad === 'virtual' ? 'Virtual' : 'Presencial'} (${plan.duration}) por ${plan.price}`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  const planesActuales = (modalidad === 'virtual' ? planesVirtual : planesPresencial)
    .filter((plan) => !plan.hidden);

  return (
    <div className="planes-container">
      <h2>
        <span>Planes Nutricionales</span>{' '}
        <span>Personalizados</span>
      </h2>

      <div className="button-container">
        <button
          className={`button ${modalidad === 'virtual' ? 'active' : ''}`}
          onClick={() => handleModalidadChange('virtual')}
        >
          Modalidad Virtual
        </button>
        <button
          className={`button ${modalidad === 'presencial' ? 'active' : ''}`}
          onClick={() => handleModalidadChange('presencial')}
        >
          Modalidad Presencial
        </button>
      </div>

      <div className="planes-grid">
        {planesActuales.map((plan) => (
          <div key={plan.id} className={`plan ${plan.popular ? 'popular' : ''}`}>
            {plan.popular && <div className="popular-badge">Más Popular</div>}
            <div className="plan-header">
              <h3>{plan.title}</h3>
              <p className="duration">⏱ {plan.duration}</p>
            </div>
            <div className="description">
              <p className="description-title">Incluye:</p>
              {plan.description.map((item, index) => (
                <p key={index} className="description-line">
                  <span className="checkmark">✓</span>
                  {item}
                </p>
              ))}
            </div>
            <div className="recommendation">
              <span className="recommendation-icon">👉</span>
              <span>{plan.recommendation}</span>
            </div>
            <p className="price">{plan.price}</p>
            <button 
              className="btn"
              onClick={() => handleWhatsAppClick(plan)}
            >
              ¡Empieza Ahora!
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Planes;